module.exports = __webpack_public_path__ + "img/mic14.6f555948.jpg";